<template>
  <div>
    <div class="entryMain" @mousewheel="mousewheel">
      <div class="logoImg">
        <img src="../../static/images/entry_logo.png" alt="">
      </div>
      <div class="titleImg">
        <img src="../../static/images/entry_title.png" alt="">
      </div>
      <div class="entryListBox">
        <div class="activityEntry">
          <div class="listTitle">
            <div class="entryImg">
              <img src="../../static/images/entry.png" width="39" height="32" alt="">
            </div>
            <div>微能力认证活动入口</div>
          </div>
          <div>
            <div class="oneActivityTab" v-for="(act,idx) in activityTabList" :key="idx" @click="gohref(act.url)">
              <a-tooltip placement="bottom">
                <template slot="title" v-if="activityTabListText[idx]">
                  {{ activityTabListText[idx] }}
                </template>
                {{act.name}}
              </a-tooltip>
            </div>
          </div>
        </div>
        <div class="resourceEntry">
          <div class="listTitle">
            <div class="linkImg">
              <img src="../../static/images/link.png" width="32" height="32" alt="">
            </div>
            <div>活动相关资源平台</div>
          </div>
          <div>
            <div class="oneResourceTab" v-for="(res,idx) in resourceTabList" :key="idx" @click="gohref(res.url)">{{res.name}}</div>
          </div>
        </div>
      </div>
      <div class="botttomContent">
        <div class="msgDesc">
          <div class="msgImg">
            <img src="../../static/images/msgTitle.png" alt="">
          </div>
          <div class="msgInfo">
            <ul>
              <li v-for="(msg,idx) in msgInfoList" :key="idx" @click="gohref(msg.url)">{{msg.name}}</li>
            </ul>
          </div>
        </div>
        <div class="downBox" @click="toHome">
          <img src="../../static/images/todown.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'entry',
        data () {
          return {
            activityTabList: [
              {name: '微能力线上课程培训', url: '/match/microTrain'},
              {name: '微能力认证材料提交', url: 'http://gzts.gzteacher.com/person/login1?projectId=1608f1f4c46f43f0b119d214e3fb1a89'},
              {name: '微能力认证专家评审', url: 'http://gzgl.gzteacher.com/'},
              {name: '数字教材课例观摩与微能力解课', url: '/match/videoClass'}
            ],
            activityTabListText:[
              '', '', '', ''
            ],
            resourceTabList: [
              {name: '广东省中小学教师信息技术应用能力提升工程2.0', url: 'https://jstsgc.gdedu.gov.cn/info2/gateway/route/mobile/goIndex.action#'},
              {name: '广州市中小学教师信息技术应用能力提升工程', url: 'http://tsgc.gzedu.com/index/GZTSGC_SY.html'},
              {name: '广东省教育双融双创智慧共享社区', url: 'https://srsc.gdedu.gov.cn/srsc/login/login.jsp#'},
              {name: '天河区基础教育“幼有善育、学有优教”幸福标杆行动计划', url: 'http://eezxyl.gzedu.com/?furl=https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=6ad3c025ac884617806ab4d8100b3d11'}
            ],
            msgInfoList: [
              {name: '广州市中小学教师信息技术应用能力提升工程2.0实施方案', url: 'http://eezxyl.gzedu.com/?furl=https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=4083364e8b5f4b7fa34a330fb11ff2b3'},
              {name: '广东省教育厅关于印发国家课程教学教材规横化应用全覆盖实施方案的通知', url:'http://eezxyl.gzedu.com/?furl=https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=1a1593cfe38e475ab6b7eb27a8b2d16b'},
              {name: '广州市教育局关于公示广州市中小学教师信息技术应用能力提升工程2.0试点校拟认定名单的通知', url: 'http://jyj.gz.gov.cn/yw/wsgs/content/post_6906455.html'},
              {name: '广州天河：优教行动夯实优质均衡路', url: 'http://www.thnet.gov.cn/gzjg/qzf/qjyj/jyxw/content/mpost_6498785.html'},
              {name: '天河区召开教育大会 实施优教行动打造幸福标杆', url: 'http://www.thnet.gov.cn/gzjg/qzf/qjyj/jyxw/content/mpost_6519803.html'},
              {name: '关于开展广东省教育“双融双创”行动暨2020年教育教学信息化交流展示活动的通知', url: 'https://srsc.gdedu.gov.cn/srsc/pub/tnotice/notice.do?act=notice&vccode=inform0000002190'}
            ]
          };
        },
        mounted () {
          this.getUa();
        },
        methods: {
          gohref(url){
            if (url){
              window.open(url);
            } else {
              // this.$success({
              //   title: '提示',
              //   // JSX support
              //   content: (
              //     <div>
              //       所有课程将于11月23日上线，敬请期待！！
              //     </div>
              //   ),
              // });
            }
          },
          toHome(){
            this.$router.push({path: '/home'});
          },
          getUa(){
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              console.log('手机');
              this.$router.push({path: '/h5'});
            } else {
              console.log('pc');
              // this.$router.push({path: '/match'});
            }
          },
          mousewheel(e){
            console.log(e);
            if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
              if (e.wheelDelta < 0) { //当滑轮向上滚动时
                this.$router.push({path: '/home'});
              }
            } else if (e.detail) {  //Firefox滑轮事件
              if (e.detail < 0) { //当滑轮向上滚动时
                this.$router.push({path: '/home'});
              }
            }
          }
        }
    };
</script>
<style lang="less" scoped>

.entryMain{
  height: 100vh;
  background: url('../../static/images/banner.png') no-repeat;
  background-size: 100% 100%;
  padding: 28px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  img{
    width: 100%;
    height: 100%;
  }
  .logoImg{
      width: auto;
    height: 13vh;
  }
  .logoImg img{
    width: auto;
  }
  .titleImg{
    width: auto;
    height: 13vh;
  }
  .titleImg img{
    width: auto;
  }
  .entryImg{
    width: 39px;
    height: 32px;
    margin-right: 16px;
  }
  .linkImg{
    width: 32px;
    height: 32px;
    margin-right: 16px;
  }
  .entryListBox{
    width: 980px;
    display: flex;
    justify-content: space-between;
    margin: 27px 0 35px;
    .listTitle{
      display: flex;
      justify-content: center;
      align-items: center;
      div{
        font-size: 20px;
        color: #fff;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-shadow: 0px 5px 10px rgba(0, 0, 0, 0.16);
      }
    }
    .activityEntry{
      width: 330px;
      .oneActivityTab{
        height: 44px;
        line-height: 44px;
        background: linear-gradient(180deg, #FBD437 0%, #FCC352 100%);
        opacity: 1;
        border-radius: 4px;
        margin-top: 14px;
        font-size: 16px;
        cursor: pointer;
        &:hover{
          opacity: 0.8;
        }
      }
    }
    .resourceEntry{
      width: 573px;
      .oneResourceTab{
        font-size: 16px;
        height: 44px;
        line-height: 44px;
        background: linear-gradient(180deg, #04A9F5 0%, #049DF5 100%);;
        opacity: 1;
        border-radius: 4px;
        margin-top: 14px;
        color: #fff;
        cursor: pointer;
        &:hover{
          opacity: 0.8;
        }
      }
    }
  }
  .botttomContent{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 22vh;
    // height: 20%;
    background: #54209E;
    // border-top: 1px dashed #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 15px;
    .msgDesc{
      width: 980px;
      display: flex;
      .msgImg{
        width: 145px;
        height: 145px;
        margin-right: 30px;
      }
      .msgInfo{
        text-align: left;
        li{
          font-size: 16px;
          line-height: 26px;
          color: #FFFFFF;
          list-style: disc;
          cursor: pointer;
          &:hover{
            color: #1890FF;
          }
        }
      }
    }
    .downBox{
      width: 50px;
      height: 50px;
      bottom: 5px;
      right: 30px;
      cursor: pointer;
      position: absolute;
      animation: mymove 0.5s infinite;
      animation-direction: alternate;
    }
  }
}
@keyframes mymove
{
	from {transform: translate(0, 0);}
	to {transform: translate(0, -20px);}
}
</style>
